import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SettingsIcon from "@mui/icons-material/Settings";
import { useEffect } from "react";
import { IconButton, TextField } from "@mui/material";
import axios from "../../api/PrivateApi";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function ResearchSettings() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [roles, setRoles] = useState([]);
  const [newRoles, setNewRoles] = useState([]);
  const [editing, setEditing] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarInfo, setSnackbarInfo] = useState({});
  const [confirmDelete, setConfirmDelete] = useState({
    id: null,
    confirm: false,
  });
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const fetchData = async () => {
    const roles = await axios.get("/research/roles");
    setRoles(roles.data);
    console.log("roles: ", roles);
  };

  const handleClose = () => {
    fetchData();
    setEditing(false);
    setNewRoles([]);
    setConfirmDelete({ id: null, confirm: false });
    setRoles((prev) => {
      return prev
        .filter((role) => {
          return role?.new === undefined;
        })
        .map((role) => role);
    });
    setAnchorEl(null);
  };

  const saveNewRole = async () => {
    const post = await axios.post("research/updateRoles", { values: roles });
    const add = await axios.post("research/addRole", { values: newRoles });
    setEditing(false);
    setNewRoles({});
    setRoles((prev) => {
      const updRoles = prev.map((role) => {
        if (role?.new === undefined) {
          return role;
        }
        let a = {
          id: role.id,
          type: role.type,
          role_load: role.role_load,
          Staff_Researches: [],
        };
        return a;
      });
      return updRoles;
    });
    handleSnackbarOpen("success", "Role updated successfully!");
  };

  const handleAddNewRole = () => {
    setEditing(true);
    let id = roles.length + 10;
    setNewRoles((prev) => [
      ...prev,
      { id: id, type: "", role_load: 0, new: true },
    ]);
    setRoles((prev) => {
      return [...prev, { id: id, type: "", role_load: 0, new: true }];
    });
  };

  const changeRole = (event, role_id) => {
    setEditing(true);
    const value = event.target.value;
    const updatedRoles = roles.map((role) => {
      if (role.id === role_id) return { ...role, role_load: value };
      return role;
    });
    setRoles(updatedRoles);

    const newBeingAddedRoles = newRoles.map((role) => {
      if (role.id === role_id) return { ...role, role_load: value };
      return role;
    });
    setNewRoles(newBeingAddedRoles);
  };

  const newRoleType = (event, role_id) => {
    const value = event.target.value;
    console.log("newvalue: ", role_id);
    const newBeingAddedRoles = newRoles.map((role) => {
      if (role.id === role_id) return { ...role, type: value };
      return role;
    });
    setNewRoles(newBeingAddedRoles);
    const newBeingAdded = roles.map((role) => {
      if (role.id === role_id) return { ...role, type: value };
      return role;
    });
    setRoles(newBeingAdded);
  };

  const handleDeleteRole = async (role_id, isNew = false) => {
    setRoles((prev) => {
      return prev.filter((role) => role.id !== role_id).map((role) => role);
    });

    if (!isNew) {
      let post = await axios.post("research/deleteRole", { role_id: role_id });
      handleSnackbarOpen("success", "Role deleted successfully!");
    }

    setConfirmDelete({ id: null, confirm: false });
  };

  const handleConfirmDelete = (role_id) => {
    setConfirmDelete({ id: role_id, confirm: true });
  };

  const handleCancelDelete = () => {
    setConfirmDelete({ id: null, confirm: false });
  };

  const handleSnackbarOpen = (type, message) => {
    setSnackbarOpen(true);
    setSnackbarInfo({ type: type, message: message });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarOpen(false);
    setSnackbarInfo({});
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <h2 color="primary" style={{ textAlign: "center", marginBottom: '10px' }}>
        Change Role Load
      </h2>
      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
        {/* <Button
        onClick={handleClick}
        variant="outlined"
        color="primary"
        sx={{ mb: 2, alignSelf: "right" }}
      >
        <SettingsIcon /> Settings
      </Button> */}
        {/* <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={true}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{ padding: "30px" }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      > */}
        <div style={{ width: '100%' }}>
          <table style={{ width: '100%' }}>
            {roles.map((role) => {
              if (role?.new)
                return (
                  <MenuItem disableRipple key={role.id} sx={{ width: "100%", }} >
                    <tr>
                      <td style={{ width: '50%', marginRight: "20px" }}>
                        <TextField
                          sx={{ width: "225px", marginRight: "20px" }}
                          variant="outlined"
                          placeholder="New Role"
                          label={"New Role"}
                          onChange={(event) => newRoleType(event, role.id)}
                        />
                      </td>
                      <td style={{ width: '50%', marginRight: "20px" }}>
                        <TextField
                          sx={{ width: '58vw', marginRight: "20px" }}
                          variant="outlined"
                          label={"Role Load"}
                          placeholder="Role Load"
                          onChange={(event) => changeRole(event, role.id)}
                        />
                      </td>
                    </tr>

                    <IconButton
                      onClick={() => handleDeleteRole(role.id, true)}
                      variant="outlined"
                      // sx={{ marginLeft: 2 }}
                      size="large"
                    >
                      <DeleteOutlinedIcon color="error" />
                    </IconButton>
                  </MenuItem>
                );

              // POPULATED FROM THE DATABASE
              return (
                <MenuItem sx={{ width: "100%", }} disableRipple key={role.id}>
                  <tr>
                    <td style={{ width: "250px" }}>
                      <span style={{ marginRight: "25px", fontWeight: "bold" }}>
                        {role.type}:
                      </span>{" "}
                    </td>
                    <td>
                      <TextField
                        onChange={(event) => changeRole(event, role.id)}
                        variant="outlined"
                        label={role.type}
                        value={role.role_load}
                        sx={{ width: '58vw' }}
                      />
                    </td>
                  </tr>
                  {confirmDelete.confirm && confirmDelete.id === role.id ? (
                    <div style={{ marginLeft: "10px" }}>
                      <Button
                        size="small"
                        color="error"
                        variant="contained"
                        sx={{ mr: 1 }}
                        onClick={() => handleDeleteRole(role.id, false)}
                      >
                        Delete
                      </Button>
                      <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        sx={{ mr: 1, fontWeight: "bold" }}
                        onClick={handleCancelDelete}
                      >
                        Cancel
                      </Button>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        width: confirmDelete.confirm ? "150px" : "",
                      }}
                    >
                      <IconButton
                        onClick={() => handleConfirmDelete(role.id)}
                        variant="outlined"
                        sx={{ marginLeft: 2 }}
                        size="large"
                        disabled={role.Staff_Researches.length > 0 ? true : ""}
                      >
                        <DeleteOutlinedIcon
                          sx={{
                            opacity:
                              role.Staff_Researches.length > 0 ? "50%" : "",
                          }}
                          color="error"
                        />
                      </IconButton>
                    </div>
                  )}
                </MenuItem>
              );
            })}
          </table>
          {/* BUTTONS */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "15px",
              width: '100%'
            }}
          >
            <div className="">
              <Button
                onClick={handleAddNewRole}
                variant="outlined"
                color="primary"
                sx={{ ml: 2, alignSelf: "start" }}
              >
                Add Role
              </Button>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "end",
                justifyContent: "end",
                marginTop: 6,
                marginBottom: 6,
              }}
            >
              {editing ? (
                <Button
                  onClick={() => {
                    saveNewRole();
                  }}
                  variant="contained"
                  color="primary"
                  sx={{ mr: 2 }}
                >
                  Save
                </Button>
              ) : null}
              <Button
                onClick={handleClose}
                variant="contained"
                color="secondary"
                sx={{ mr: 2 }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>

        {/* </Menu> */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarInfo.type}
            sx={{ width: "100%" }}
          >
            {snackbarInfo.message}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
}
